<template>
    <div ref="app" id="app">
        <section id="app-content" v-if="textLoaded">
            <Hamburger />
            <Nav />
            <router-view />
            <HintCanvas id="hintCanvas" aria-hidden=true />
            <Footer />
        </section>
        <Loading v-if="textLoading" /> 
        <Error v-if="textError" :message="textErrorMsg" />

        <vue-announcer role="presentation" />
    </div>
</template>

<script>
import { mapGetters } from "vuex"

import Error from '@/components/Error'
import Loading from '@/components/Loading'

import Footer from '@/components/meta/Footer'
import Hamburger from '@/components/meta/Hamburger'
import Logo from '@/components/meta/Logo'
import Nav from '@/components/meta/Nav'

import HintCanvas from '@/components/common/HintCanvas'



export default {
    components: {
        Error,
        Footer,
        Hamburger,
        Loading,
        Logo,
        Nav,
        HintCanvas
    },
    computed: {
        ...mapGetters({
            "textError" : "text/error",
            "textErrorMsg" : "text/error_msg",
            "textLoading" : "text/loading",
            "textLoaded" : "text/loaded"
        }),
    },
    mounted() {
        this.$store.dispatch("text/load");
        this.$store.dispatch("sst/load");
        this.$store.dispatch("otolith/load")

        this.$setAppElement(this.$refs.app);

        // Handle Key Presses
        document.onkeydown = (evt) => {
            if (evt.key === "Escape" || evt.key === "Esc") {
                this.$store.dispatch("global/toggleNav")
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_vars.scss";

#app {
    height: 100%;
    left: 0;
    position: absolute;
    overflow: hidden;
    top: 0;
    width: 100%;
    z-index: 0;
}
</style>

